import type { TeamRole } from '@/api-models/teams';

/** Vivid avatar/tile colors, drawn from the accent ramp, keyed deterministically off an id. */
const TILE_COLORS = ['#5048e8', '#46b6f0', '#3dd68c', '#f5b83d', '#f76c6c', '#a855f7', '#f97316'];

export function tileColor(id: string): string {
  let hash = 0;
  for (let i = 0; i < id.length; i++) hash = (hash + id.charCodeAt(i)) % TILE_COLORS.length;
  return TILE_COLORS[hash] ?? TILE_COLORS[0]!;
}

export const TEAM_ROLE_LABEL: Record<TeamRole, string> = {
  owner: 'Owner',
  admin: 'Admin',
  member: 'Member',
};

/** Up to two uppercase initials from a name or email local-part. */
export function initials(value: string): string {
  const base = value.includes('@') ? (value.split('@')[0] ?? value) : value;
  return (
    base
      .split(/[\s._-]+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((w) => w[0]?.toUpperCase() ?? '')
      .join('') || base.charAt(0).toUpperCase()
  );
}
